// Analytics configuration based on environment
// Mirrors the Ruby ApplicationConfig::GoogleAnalytics and ApplicationConfig::Intercom

interface AnalyticsConfig {
  googleAnalytics: {
    tagManagerContainer: string;
  };
  intercom: {
    appId: string;
  };
}

const getAnalyticsConfig = (): AnalyticsConfig => {
  const nodeEnv = process.env.NODE_ENV || 'development';

  switch (nodeEnv) {
    case 'production':
      return {
        googleAnalytics: {
          tagManagerContainer: process.env.PRODUCTION_GTM_ID || 'GTM-5HSWD9',
        },
        intercom: {
          appId: process.env.PRODUCTION_INTERCOM_APP_ID || 'tv6jsyee',
        },
      };

    case 'staging':
      return {
        googleAnalytics: {
          tagManagerContainer: process.env.STAGING_GTM_ID || 'GTM-P2DH5X',
        },
        intercom: {
          appId: process.env.STAGING_INTERCOM_APP_ID || 't2bi7urt',
        },
      };

    case 'development':
    default:
      return {
        googleAnalytics: {
          tagManagerContainer: process.env.STAGING_GTM_ID || 'GTM-P2DH5X',
        },
        intercom: {
          appId: '', // No Intercom in development
        },
      };
  }
};

export const analyticsConfig = getAnalyticsConfig();
